export default __webpack_public_path__ + "static/media/7.9ef0b180.png";